import { Col, Container, Tab, Row, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";

import team1 from "../assets/img/product.webp";
import team2 from "../assets/img/lifestyle.webp";
import team3 from "../assets/img/corporate2.webp";
import team4 from "../assets/img/event2.webp";
import team5 from "../assets/img/interior2.webp";
import team6 from "../assets/img/fashion.webp";

import img7 from "../assets/img/travel.webp";
import img8 from "../assets/img/shadow.webp";
import img9 from "../assets/img/motion.webp";
import img10 from "../assets/img/process.webp";
import img11 from "../assets/img/behind.webp";
import img12 from "../assets/img/team.webp";

export const Projects = () => {
  const projects = [
    {
      title: "Product Photography",
      description: "Showcasing products with precision",
      imgUrl: team1,
    },
    {
      title: "Lifestyle Photography",
      description: "Capturing authentic, everyday moments",
      imgUrl: team2,
    },
    {
      title: "Corporate Headshots",
      description: "Professional portraits for businesses",
      imgUrl: team3,
    },
    {
      title: "Event Photography",
      description: "Documenting events with storytelling imagery",
      imgUrl: team4,
    },
    {
      title: "Architecture Photography",
      description: "Highlighting buildings' design and structure",
      imgUrl: team5,
    },
    {
      title: "Fashion Photography",
      description: "Stylized visuals for clothing brands",
      imgUrl: team6,
    },
  ];

  const projects2 = [
    {
      title: "Urban Exploration",
      description: "Finding Beauty in the Overlooked Corners of the City",
      imgUrl: img7,
    },
    {
      title: "Moments in Motion",
      description: "Capturing Fleeting Instants of Everyday Life",
      imgUrl: img9,
    },
    {
      title: "Light and Shadow Play",
      description: "Experimenting with Contrast to Create Dramatic Visuals",
      imgUrl: img8,
    },
  ];

  const projects3 = [
    {
      title: "The Creative Process",
      description: "Witness the Journey from Concept to Capture",
      imgUrl: img10,
    },
    {
      title: "Behind the Lens",
      description: "Explore the Techniques and Tools in Action",
      imgUrl: img11,
    },
    {
      title: "Teamwork in Focus",
      description: "Collaboration That Brings Visions to Life",
      imgUrl: img12,
    },
  ];

  return (
    <section className="project" id="services">
      <Container>
        <Row>
          <Col>
            <h2>Services</h2>
            <h3>
              Comprehensive Photography Services, Customized to Your Needs
            </h3>
            <p>
              I offer a range of commercial photography services, including
              product photography, corporate headshots, lifestyle imagery,
              architecture, and events. Whether you need dynamic images for your
              brand’s website, promotional campaigns, or professional
              portfolios, I adapt my style and approach to meet the unique needs
              of each project.
            </p>
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center align-items-center"
                id="pills-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">Categories</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Recent Personal Work</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Behind The Scenes</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Row>
                    {projects.map((project, index) => {
                      return <ProjectCard key={index} {...project} />;
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <p>
                    Discover my latest photography projects across various
                    industries. These images reflect my current work and
                    commitment to capturing exceptional visuals.
                  </p>
                  <Row>
                    {projects2.map((project, index) => {
                      return <ProjectCard key={index} {...project} />;
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <p>
                    Step behind the camera and see how I bring concepts to life.
                    From setup to final shot, here’s a glimpse of my creative
                    process.
                  </p>
                  <Row>
                    {projects3.map((project, index) => {
                      return <ProjectCard key={index} {...project} />;
                    })}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
